import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.list-unmatched-credit-card-items.presenters.UnmatchedCreditCardItemListPresenter`

export default defineMessages({
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  genericErrorMessage: {
    id: `${scope}.genericErrorMessage`,
    defaultMessage: 'Unable to load the unmatched credit card items.',
  },
})
